/* External gallery lightbox: thumbnail grid -> <dialog> viewer with
   prev/next, keyboard, and swipe navigation. Dependency-free. */
(function () {
  'use strict';

  class SAExternalGallery extends HTMLElement {
    connectedCallback() {
      if (this._initialised) return;
      this._initialised = true;

      var dataNode = this.querySelector('[data-sa-extgal-urls]');
      try {
        this.urls = JSON.parse(dataNode ? dataNode.textContent : '[]');
      } catch (e) {
        this.urls = [];
      }
      // Defense-in-depth: only ever handle absolute https URLs.
      this.urls = (Array.isArray(this.urls) ? this.urls : []).filter(function (u) {
        return typeof u === 'string' && /^https:\/\//i.test(u);
      });
      this.index = 0;
      this.dialog = this.querySelector('.sa-extgal__lightbox');
      this.stage = this.querySelector('[data-sa-extgal-stage]');
      this.counter = this.querySelector('[data-sa-extgal-counter]');
      if (!this.dialog || !this.stage || !this.urls.length) return;

      var self = this;

      this.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-sa-extgal-index]');
        if (thumb) {
          self.open(parseInt(thumb.getAttribute('data-sa-extgal-index'), 10) || 0);
          return;
        }
        if (event.target.closest('[data-sa-extgal-prev]')) self.step(-1);
        if (event.target.closest('[data-sa-extgal-next]')) self.step(1);
        if (event.target.closest('[data-sa-extgal-close]')) self.dialog.close();
      });

      // Close when clicking the backdrop (outside the figure).
      this.dialog.addEventListener('click', function (event) {
        if (event.target === self.dialog) self.dialog.close();
      });

      this.dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          self.step(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          self.step(1);
        }
      });

      // Basic swipe navigation.
      var touchX = null;
      this.dialog.addEventListener('touchstart', function (event) {
        touchX = event.changedTouches[0].clientX;
      }, { passive: true });
      this.dialog.addEventListener('touchend', function (event) {
        if (touchX === null) return;
        var dx = event.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) > 40) self.step(dx > 0 ? -1 : 1);
      }, { passive: true });

      this.initSlider();
    }

    // Horizontal thumbnail slider: arrow buttons + overflow detection.
    initSlider() {
      var self = this;
      this.track = this.querySelector('[data-sa-extgal-track]');
      this.slider = this.querySelector('.sa-extgal__slider');
      if (!this.track || !this.slider) return;

      var prevBtn = this.querySelector('[data-sa-extgal-scroll="prev"]');
      var nextBtn = this.querySelector('[data-sa-extgal-scroll="next"]');

      var update = function () {
        var maxScroll = self.track.scrollWidth - self.track.clientWidth;
        self.slider.classList.toggle('sa-extgal__slider--scrollable', maxScroll > 2);
        if (prevBtn) prevBtn.disabled = self.track.scrollLeft <= 1;
        if (nextBtn) nextBtn.disabled = self.track.scrollLeft >= maxScroll - 1;
      };

      this.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-sa-extgal-scroll]');
        if (!btn) return;
        event.preventDefault();
        var dir = btn.getAttribute('data-sa-extgal-scroll') === 'prev' ? -1 : 1;
        self.track.scrollBy({ left: dir * self.track.clientWidth * 0.85, behavior: 'smooth' });
      });

      this.track.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', function () {
        window.requestAnimationFrame(update);
      });

      update();
      // Re-check once thumbnails have loaded and influenced layout.
      window.setTimeout(update, 300);
    }

    open(index) {
      this.index = index;
      this.paint();
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    step(delta) {
      var n = this.urls.length;
      this.index = (this.index + delta + n) % n;
      this.paint();
    }

    paint() {
      this.stage.src = this.urls[this.index];
      this.stage.alt = 'Photo ' + (this.index + 1) + ' of ' + this.urls.length;
      if (this.counter) {
        this.counter.textContent = (this.index + 1) + ' / ' + this.urls.length;
      }
      // Preload neighbours for snappy navigation.
      var n = this.urls.length;
      [this.urls[(this.index + 1) % n], this.urls[(this.index - 1 + n) % n]].forEach(function (u) {
        var img = new Image();
        img.src = u;
      });
    }
  }

  if (window.customElements && !window.customElements.get('sa-external-gallery')) {
    window.customElements.define('sa-external-gallery', SAExternalGallery);
  }
})();
